import React, { useState } from 'react';

import Header from './header';
import Footer from './footer';
import Main from './main';
import Sidebar from "@/layouts/sidebar";

import { styled } from "@mui/material/styles";
import HeaderMinimal from "@/layouts/header/minimal";

const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden'
});

const Layout: React.FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <RootStyle>
            <Header onOpenSidebar={() => setOpen(true)} />
            <HeaderMinimal />
            <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
            <Main />
            <Footer />
        </RootStyle>
    );
};

export default Layout;
